import { render, staticRenderFns } from "./DesktopNavigationNode.vue?vue&type=template&id=0510093c"
import script from "./DesktopNavigationNode.vue?vue&type=script&lang=js"
export * from "./DesktopNavigationNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports